/* ## Hooks ## */
import { useEffect, useState } from 'react'
import CardCentralLogin from '../../../assets/imgs/card-central-login.png'
import xamaLogoWhite from '../../../assets/logos/xama-ai_purple.png'
import {
  getBusinessByLogin,
  postBusiness,
  putBusiness,
} from '../../../services/business'
import {
  getAllBusinessNiche,
  getBusinessNichebyId,
  postBusinessNiche,
  putBusinessNiche,
} from '../../../services/businessNicheService'
import { notifyErrorCustom } from '../../../utils/notify'
import styles from './styles.module.css'

import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { FooterNaviBar } from '../../../components/FooterNaviBar'
import {
  BrandingService,
  BusinessService,
  EditorialLineService,
  EventMapService,
  OrchestratorTextGenerationService,
  ProductService,
  PythonService,
  TargetAudienceService,
  UserAccountsService,
  VoiceToneService,
} from '../../../services'
import { sendBusinessInfoCompletedAnalyticsEvent } from '../../../services/analytics-metrics.service'
import { useGoogleAdsTracking } from '../../../utils/googleAdsTracking'

const storage = window.localStorage

const STEPS = {
  STEP_COLOR_PALETTE: 'stepColorPalette',
  STEP_FIRST_PASS: 'stepFirstPass',
}

const CHAT_SOCKET_REDIRECT_RELEASE_DATE = new Date(2026, 2, 16)

const isOnOrAfterDate = (currentDate, referenceDate) => {
  const normalizedCurrentDate = new Date(currentDate)
  const normalizedReferenceDate = new Date(referenceDate)

  normalizedCurrentDate.setHours(0, 0, 0, 0)
  normalizedReferenceDate.setHours(0, 0, 0, 0)

  return normalizedCurrentDate >= normalizedReferenceDate
}

function StepNinche({
  setStep,
  colorsArray,
  setOverlay,
  setLoading,
  initialParameterizationFlow = false,
}) {
  const { t } = useTranslation()
  const { updateUrlWithNicheEvent } = useGoogleAdsTracking()
  const [nicheSelected, setNicheSelected] = useState('')
  const [nicheSelectedLabel, setNicheSelectedLabel] = useState('')

  const [businessDescription, setBusinessDescriprion] = useState('')
  const [otherNicheValue, setOtherNicheValue] = useState('')

  const [primeiraMetade, setPrimeiraMetade] = useState([])
  const [segundaMetade, setSegundaMetade] = useState([])

  const [businessAccount, setBusinessAccount] = useState(false)
  const [objectiveSelected, setObjectiveSelected] = useState([])
  const navigate = useNavigate()

  const stepsArray = [
    {
      pass: '1º Passo',
      title: 'Nicho e Objetivo',
      current: true,
    },
    {
      pass: '2º Passo',
      title: 'Paleta de cores',
      current: false,
    },
    {
      pass: '3º Passo',
      title: 'Fontes',
      current: false,
    },
    {
      pass: '4º Passo',
      title: 'BPS',
      current: false,
    },
    {
      pass: '5º Passo',
      title: 'Tom de Voz',
      current: false,
    },
    {
      pass: '6º Passo',
      title: 'Objetivo',
      current: false,
    },
    {
      pass: '7º Passo',
      title: 'Logo',
      current: false,
    },
    {
      pass: '8º Passo',
      title: 'Imagem',
      current: false,
    },
    {
      pass: '9º Passo',
      title: 'Geração de Arte',
      current: false,
    },
    {
      pass: '10º Passo',
      title: 'Download',
      current: false,
    },
  ]

  const languageForObjectives = storage.i18nextLng
  const objetiveOptions =
    languageForObjectives == 'en'
      ? [
        { label: 'Engagement', value: '01' },
        { label: 'Sales', value: '02' },
        { label: 'Range', value: '03' },
        { label: 'Launch', value: '04' },
      ]
      : languageForObjectives == 'es'
        ? [
          { label: 'Compromiso', value: '01' },
          { label: 'Ventas', value: '02' },
          { label: 'Alcance', value: '03' },
          { label: 'Lanzamiento', value: '04' },
        ]
        : [
          { label: 'Engajamento', value: '01' },
          { label: 'Vendas', value: '02' },
          { label: 'Alcance', value: '03' },
          { label: 'Lançamento', value: '04' },
        ]

  const businessList = [
    {
      value: 'Advocacia e Serviços Jurídicos',
      valueEn: 'Law and Legal Services',
      valueEs: 'Servicios Legales y Abogacía',
    },
    {
      value: 'Agricultura e Agronegócio',
      valueEn: 'Agriculture and Agribusiness',
      valueEs: 'Agricultura y Agronegocios',
    },
    { value: 'Alimentos e Bebidas', valueEn: 'Food and Beverages', valueEs: 'Alimentos y Bebidas' },
    { value: 'Alimentos Orgânicos', valueEn: 'Organic Food', valueEs: 'Alimentos Orgánicos' },
    { value: 'Arte e Cultura', valueEn: 'Art and Culture', valueEs: 'Arte y Cultura' },
    { value: 'Automotivo', valueEn: 'Automotive', valueEs: 'Automotriz' },
    { value: 'Barbearia', valueEn: 'Barbershop', valueEs: 'Barbería' },
    { value: 'Beleza e Salão', valueEn: 'Beauty and Salon', valueEs: 'Belleza y Salón' },
    { value: 'Cafeteria', valueEn: 'Cafeteria', valueEs: 'Cafetería' },
    {
      value: 'Coaching e Desenvolvimento Pessoal',
      valueEn: 'Coaching and Personal Development',
      valueEs: 'Coaching y Desarrollo Personal',
    },
    { value: 'Educação', valueEn: 'Education', valueEs: 'Educación' },
    { value: 'Entretenimento', valueEn: 'Entertainment', valueEs: 'Entretenimiento' },
    { value: 'Esportes e Fitness', valueEn: 'Sports and Fitness', valueEs: 'Deportes y Fitness' },
    {
      value: 'Imóveis e Construção Civil',
      valueEn: 'Real Estate and Construction',
      valueEs: 'Bienes Raíces y Construcción',
    },
    { value: 'Indústria Farma', valueEn: 'Pharmaceutical Industry', valueEs: 'Industria Farmacéutica' },
    { value: 'Joias', valueEn: 'Jewelry', valueEs: 'Joyería' },
    { value: 'Jogos / Gaming', valueEn: 'Games / Gaming', valueEs: 'Juegos / Gaming' },
    { value: 'Marketing e Publicidade', valueEn: 'Marketing and Advertising', valueEs: 'Marketing y Publicidad' },
    { value: 'Moda e Vestuário', valueEn: 'Fashion and Clothing', valueEs: 'Moda y Vestimenta' },
    { value: 'Móveis e Decoração', valueEn: 'Furniture and Decoration', valueEs: 'Muebles y Decoración' },
    { value: 'Pet Care', valueEn: 'Pet Care', valueEs: 'Cuidado de Mascotas' },
    { value: 'Saúde e Bem-estar', valueEn: 'Health and Well-being', valueEs: 'Salud y Bienestar' },
    { value: 'Serviços Empresariais', valueEn: 'Business Services', valueEs: 'Servicios Empresariales' },
    { value: 'Serviços Financeiros', valueEn: 'Financial Services', valueEs: 'Servicios Financieros' },
    { value: 'Serviços de RH', valueEn: 'HR Services', valueEs: 'Servicios de RRHH' },
    {
      value: 'Sustentabilidade e Energia',
      valueEn: 'Sustainability and Energy',
      valueEs: 'Sostenibilidad y Energía',
    },
    { value: 'Tecnologia', valueEn: 'Technology', valueEs: 'Tecnología' },
    { value: 'Viagem e Turismo', valueEn: 'Travel and Tourism', valueEs: 'Viajes y Turismo' },
    { value: 'Designers', valueEn: 'Designers', valueEs: 'Diseñadores' },
    { value: 'Notícias e Jornalismo', valueEn: 'News and Journalism', valueEs: 'Noticias y Periodismo' },
    { value: 'Política', valueEn: 'Politics', valueEs: 'Política' },
    { value: 'Outro', valueEn: 'Other', valueEs: 'Otro' },
  ]

  useEffect(() => {
    loadBusinessNiches()
  }, [])

  const loadBusinessNiches = async () => {
    const storage = window.localStorage
    let data = await getAllBusinessNiche()
    const business = await BusinessService.getBusinessByLogin()

    if (business.data.length > 0) {
      // setObjectiveSelected({ label: "Engajamento", value: "01" });
      setBusinessAccount(business)
      setNicheSelected(business.data[0].businessNicheId)
      // setSubNicheSelected(business.data[0].subNiche);
      setBusinessDescriprion(business.data[0].description)
    }

      if (data.data.length <= 0) {
      for (const niche of businessList) {
        const bodyNiche = {
          name: niche.value,
          description: niche.value,
          descriptionEn: niche.valueEn,
          descriptionEs: niche.valueEs || niche.value,
        }
        const retNiche = await postBusinessNiche(bodyNiche)
      }
        const { data, responseStatus } = await getAllBusinessNiche()

      if (responseStatus === 200) {
        divideArray(
          data
            .map((e) => ({
              label:
                storage.i18nextLng == 'en'
                  ? e.descriptionEn
                  : storage.i18nextLng == 'es'
                    ? e.descriptionEs || e.description
                    : e.description,
              value: e.uuid,
            }))
            .sort((a, b) => {
              if (['Outro', 'Other', 'Otro'].includes(a.label)) return 1
              if (['Outro', 'Other', 'Otro'].includes(b.label)) return -1
              return a.label.localeCompare(b.label, undefined, {
                sensitivity: 'base',
              })
            })
        )
      }
    } else {
      if (!data.data[0].descriptionEn) {
        let i = 0
        for (const niche of businessList) {
          const bodyNiche = {
            name: niche.value,
            description: niche.value,
            descriptionEn: niche.valueEn,
            descriptionEs: niche.valueEs || niche.value,
          }
          await putBusinessNiche(data.data[i].uuid, bodyNiche)
          i++
        }
        data = await getAllBusinessNiche()
      }

      if (data.responseStatus === 200) {
        divideArray(
          data.data
            .map((e) => ({
              label:
                storage.i18nextLng == 'en'
                  ? e.descriptionEn
                  : storage.i18nextLng == 'es'
                    ? e.descriptionEs || e.description
                    : e.description,
              value: e.uuid,
            }))
            .sort((a, b) => {
              if (['Outro', 'Other', 'Otro'].includes(a.label)) return 1
              if (['Outro', 'Other', 'Otro'].includes(b.label)) return -1
              return a.label.localeCompare(b.label, undefined, {
                sensitivity: 'base',
              })
            })
        )
      }
    }
  }

  const divideArray = async (array) => {
    // Ponto de divisão
    const splitIndex = Math.ceil(array.length / 2)

    // Dividir o array
    setPrimeiraMetade(array.slice(0, splitIndex))
    setSegundaMetade(array.slice(splitIndex))
  }

  const updateFirstLogin = async () => {
    const { data: dataFirstLogin, responseStatus } =
      await UserAccountsService.getUserAccountsByLogin()

    const { ...rest } = dataFirstLogin

    delete rest.uuid
    delete rest.createdAt
    delete rest.updatedAt
    delete rest.deletedAt
    delete rest.PaymentHistory
    delete rest.freePlanChose
    delete rest.lastLogin

    if (!rest.state) {
      delete rest.state
    }

    rest.firstLogin = false
    rest.photoName = ''
    rest.photoUrl = ''

    await UserAccountsService.putUserAccountsByLogin(rest)
  }

  const handleNavigate = async (type) => {
    setLoading(true)

    if (type === 'next') {
      if (businessDescription === '') {
        notifyErrorCustom(
          t('fast_publishing_describe_an_objective_for_your_business')
        )
        setLoading(false)
        return
      }
      // if (objectiveSelected === "") {
      //   notifyErrorCustom(
      //     t("fast_publishing_choose_an_objective_for_your_post")
      //   );
      //   setLoading(false);
      //   return;
      // }

      if (nicheSelected === '') {
        notifyErrorCustom(t('fast_publishing_choose_a_niche_for_your_post'))
        setLoading(false)
        return
      }

      // if (subNicheSelected === "") {
      //   notifyErrorCustom(
      //     t("fast_publishing_include_a_subniche_for_your_post")
      //   );
      //   setLoading(false);
      //   return;
      // }

      setOverlay(false)

      const retBusiness = await createBusiness()

      await saveEditorialLine()
      await updateFirstLogin()

      const businessNicheId = retBusiness?.businessNicheId
      const nicheData = businessNicheId
        ? await getBusinessNichebyId(businessNicheId)
        : null

      if (nicheData?.responseStatus === 200) {
        updateUrlWithNicheEvent()
      }

      const dataEventniche = {
        event: 'param_niche_completed',
        eventData: {
          nichoName: nicheData?.data?.name ?? nicheSelectedLabel,
          nicheId: nicheData?.data?.uuid ?? businessNicheId,
          businessId: retBusiness?.uuid,
        },
      }
      await registerEvent(dataEventniche)

      const dataEvenProgressNiche = {
        event: 'parametrization_progress_updated',
        eventData: {
          step: 'Niche',
          percentComplete: '50%',
        },
      }
      await registerEvent(dataEvenProgressNiche)

      if (!initialParameterizationFlow) {
        const retBranding = await BrandingService.postBranding(colorsArray)

        const colors = {
          primaryColor: colorsArray.primaryColor,
          secondaryColor: colorsArray.secondaryColor,
          tertiaryColor: colorsArray.tertiaryColor,
          complementaryColor1: colorsArray.complementaryColor1,
          complementaryColor2: colorsArray.complementaryColor2,
        }
        const dataEvent = {
          event: 'param_palette_selected',
          eventData: {
            colorPalettes: colors,
            brandingId: retBranding.data.uuid,
          },
        }
        await sendBusinessInfoCompletedAnalyticsEvent()
        await registerEvent(dataEvent)
      }

      const shouldRedirectToChatSocket = isOnOrAfterDate(
        new Date(),
        CHAT_SOCKET_REDIRECT_RELEASE_DATE
      )

      if (initialParameterizationFlow) {
        navigate('/ChatSocket')
      } else if (shouldRedirectToChatSocket) {
        navigate('/ChatSocket')
      } else {
        setStep(STEPS.STEP_FIRST_PASS)
      }
    } else {
      setStep(STEPS.STEP_COLOR_PALETTE)
    }
    setLoading(false)
  }

  const registerEvent = async (data) => {
    await EventMapService.postEventMap(data)
  }

  const saveEditorialLine = async () => {
    let retEditorialLine

    let getEditorial = []

    getEditorial = await EditorialLineService.getEditorialLinebyLogin()

    const business = await BusinessService.getBusinessByLogin()
    const product = await ProductService.getProductByNotBusinessClient()
    const targetAudience =
      await TargetAudienceService.getAllTargetAudienceByNotClientId(
        ['en', 'es'].includes(storage.i18nextLng) ? storage.i18nextLng : 'ptBR'
      )

    const voiceTune = await VoiceToneService.getVoiceToneByBusiness(
      business.data[0].uuid
    )

    const data = {
      flow: 'editorial_line',
      prompt: 'editorial_line',
      business_name: business.data[0].description,

      niche: ['Outro', 'Other', 'Otro'].includes(
        business.data[0].BusinessNiche.description
      )
        ? otherNicheValue
        : storage.i18nextLng == 'en'
          ? business.data[0].BusinessNiche.descriptionEn
          : storage.i18nextLng == 'es'
            ? business.data[0].BusinessNiche.descriptionEs || business.data[0].BusinessNiche.description
            : business.data[0].BusinessNiche.description,
      subniche: business.data[0].subNiche,
      business_description: business.data[0].description,
      product: {
        name: product?.data[0]?.name ?? '',
        type: product?.data[0]?.productTypeValue ?? '',
        description: product?.data[0]?.description ?? '',
      },
      target_public: {
        name: targetAudience?.data[0]?.name ?? '',
        gender: targetAudience?.data[0]?.genderValue ?? '',
        social_class:
          targetAudience?.data[0]?.socialClassValue.join(', ') ?? '',
        profession: targetAudience?.data[0]?.profession ?? '',
        region: targetAudience?.data[0]?.stateValue ?? '',
      },
      voice_tone: voiceTune?.data[0]?.tone ?? '',
      voice_tone_description: voiceTune?.data[0]?.description ?? '',
      language:
        localStorage.i18nextLng == 'en'
          ? 'en'
          : localStorage.i18nextLng == 'es'
            ? 'es'
            : 'pt',
    }

    // retEditorialLine = await PythonService.postPromptGPT(data)
    retEditorialLine = await OrchestratorTextGenerationService.generateEditorialLine(data)

    let bodyEditorial

    bodyEditorial = {
      bodyJson: retEditorialLine?.data,
      description: 'editorial line',
    }

    if (getEditorial?.data?.length > 0) {
      await EditorialLineService.putEditorialLine(
        getEditorial?.data[0]?.uuid,
        bodyEditorial
      )
    } else {
      await EditorialLineService.postEditorialLine(bodyEditorial)
    }
  }

  const createBusiness = async () => {
    if (
      (nicheSelectedLabel === 'Outro' || nicheSelectedLabel === 'Other' || nicheSelectedLabel === 'Otro') &&
      !otherNicheValue
    ) {
      notifyErrorCustom(t('Você precisa digitar seu nicho'))

      setLoading(false)
      return
    }
    let body = {
      businessNicheId: nicheSelected,
      subNiche: '',
      description: businessDescription,
      otherNicheName: ['Outro', 'Other', 'Otro'].includes(nicheSelectedLabel)
        ? otherNicheValue
        : '',
    }

    const responseBusines = await getBusinessByLogin()

    let businessAccount

    if (responseBusines.data.length > 0) {
      await putBusiness(responseBusines?.data[0]?.uuid, body)
      businessAccount = await getBusinessByLogin()
    } else {
      businessAccount = await postBusiness(body)
    }

    return Array.isArray(businessAccount?.data)
      ? businessAccount.data[0]
      : businessAccount?.data

    // setBusinessAccountData(businessAccount)
  }

  return (
    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      style={{
        flex: 1,
        marginRight: 20,
        display: 'flex',
        zIndex: '3000',
      }}
    >
      <div className={styles.box_step}>
        <div className={styles.box_page}>
          {/* <div
            className={styles.leftContent}
            style={{
              background: `url(${CardCentralLogin})`,
              backgroundRepeat: 'no-repeat',
              objectFit: 'cover',
            }}
          >
            <div className={styles.postei_logo_field}>
              <img
                src={xamaLogoWhite}
                alt="posteiLogo"
                style={{ height: 40, width: 150, zIndex: 1 }}
                //onContextMenu={(e) => e.preventDefault()}
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                zIndex: 0,
                alignItems: 'center',
              }}
            >
              <div className={styles.sign_box_header}>
                <h1>Treine a IA com a essência da sua marca</h1>
                <p>
                  Antes de começar a criar seus posts, precisamos saber um pouco
                  sobre a identidade da sua marca. É bem rápido e você só
                  precisa fazer isso uma vez. Depois disso, é só deixar que a IA
                  faça mágica. ✨
                </p>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  zIndex: 0,
                  width: '300px',
                  gap: '15px',
                }}
              >
                <button className={styles.button_select_plan}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="25" height="25" rx="12.5" fill="#4E4E4E" />
                    <path
                      d="M12.5122 19V7.516L10.0732 8.983V7.498L12.5122 6.04H13.8532V19H12.5122Z"
                      fill="white"
                    />
                  </svg>
                  Adicione suas cores
                </button>
                <button className={styles.button_create_account}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="25" height="25" rx="12.5" fill="#000" />
                    <path
                      d="M8.7375 18.492L8.7455 17.42L13.9535 12.716C14.4015 12.3107 14.6975 11.9267 14.8415 11.564C14.9908 11.196 15.0655 10.812 15.0655 10.412C15.0655 9.93733 14.9535 9.508 14.7295 9.124C14.5055 8.74 14.2042 8.436 13.8255 8.212C13.4468 7.98267 13.0228 7.868 12.5535 7.868C12.0628 7.868 11.6255 7.98533 11.2415 8.22C10.8575 8.45467 10.5535 8.764 10.3295 9.148C10.1108 9.532 10.0042 9.95067 10.0095 10.404H8.8095C8.8095 9.70533 8.97483 9.07867 9.3055 8.524C9.63617 7.96933 10.0842 7.53467 10.6495 7.22C11.2148 6.9 11.8548 6.74 12.5695 6.74C13.2682 6.74 13.8948 6.90533 14.4495 7.236C15.0095 7.56133 15.4495 8.004 15.7695 8.564C16.0948 9.11867 16.2575 9.73733 16.2575 10.42C16.2575 10.9 16.1988 11.324 16.0815 11.692C15.9695 12.0547 15.7908 12.3933 15.5455 12.708C15.3055 13.0173 14.9988 13.3373 14.6255 13.668L10.0015 17.844L9.8175 17.364H16.2575V18.492H8.7375Z"
                      fill="white"
                    />
                  </svg>
                  Defina seu nicho
                </button>
              </div>
            </div> 
          </div> */}
          <div className={styles.rightContent}>
            <h1
              style={{
                fontSize: '45px',
                fontWeight: 500,
                height: '45px',
                textAlign: 'start',
              }}
            >
              {t('new_post_page_ia.niche')}
            </h1>

            {/* <div className={styles.container_objective}>
              <p className={styles.module_title}>
                {t("fast_publishing_define_your_objective")}
              </p>
              <div className={styles.box_objective}>
                {objetiveOptions.map((objective, index) => (
                  <div
                    className={
                      objectiveSelected?.value === objective?.value
                        ? styles.objective_selected
                        : styles.objective
                    }
                    key={index}
                    onClick={() => setObjectiveSelected(objective)}
                  >
                    <div className={styles.box_icon}>
                      <UserGroup
                        color={
                          objectiveSelected?.value === objective?.value
                            ? "#fff"
                            : "#A7A7A7"
                        }
                      />
                    </div>

                    <p
                      className={
                        objectiveSelected?.value === objective?.value
                          ? styles.objective_text_selected
                          : styles.objective_text
                      }
                    >
                      {objective.label}
                    </p>
                  </div>
                ))}
              </div>
            </div> */}

            {
              <div className={styles.container_niche}>
                <p className={styles.module_title}>
                  {t('fast_publishing_now_choose_your_niche')}
                </p>

                <div className={styles.box_niche}>
                  <div
                    className={styles.scroll_box}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      width: '100%',
                      overflowX: 'scroll',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ display: 'flex', gap: '10px' }}>
                      {primeiraMetade.map((niche, index) => (
                        <div
                          className={
                            businessAccount?.data?.businessNicheId ??
                              nicheSelected === niche.value
                              ? styles.niche_selected
                              : styles.niche
                          }
                          key={index}
                          onClick={() => setNicheSelected(niche?.value)}
                        >
                          <p className={styles.niche_label}>{niche.label}</p>
                        </div>
                      ))}
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                      {segundaMetade.map((niche, index) => (
                        <div
                          className={
                            businessAccount?.data?.businessNicheId ??
                              nicheSelected === niche.value
                              ? styles.niche_selected
                              : styles.niche
                          }
                          key={index}
                          onClick={() => {
                            setNicheSelected(niche?.value)
                            setNicheSelectedLabel(niche?.label)
                          }}
                        >
                          <p className={styles.niche_label}>{niche.label}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {(nicheSelectedLabel === 'Outro' ||
                    nicheSelectedLabel === 'Other') && (
                    <div className={styles.container_subniche}>
                      <p className={styles.module_title}>
                        {t('step_business_information.other_niche')}
                      </p>
                      <input
                        className={styles.box_input}
                        type="text"
                        value={otherNicheValue}
                        placeholder={t('step_business_information.other_niche')}
                        onChange={(e) => {
                          setOtherNicheValue(e.target.value)
                          // changesStep.current = true
                        }}
                      />
                    </div>
                  )}

                  <div className={styles.container_subniche}>
                    <p className={styles.module_title}>
                      {t('fast_publishing_define_your_business')}
                    </p>

                    <textarea
                      className={styles.textarea_subniche}
                      type="text"
                      value={businessDescription}
                      placeholder={t(
                        'fast_publishing_your_business_description'
                      )}
                      onChange={(e) => setBusinessDescriprion(e.target.value)}
                    />
                  </div>

                  {/* {objectiveSelected && nicheSelected && (
                    <div className={styles.container_subniche}>
                      <p className={styles.module_title}>
                        {t("fast_publishing_enter_your_subniche")}
                      </p>
                      <div className={styles.box_input}>
                        <input
                          className={styles.input_subniche}
                          type="text"
                          value={subNicheSelected}
                          placeholder={t("fast_publishing_your_subniche")}
                          onChange={(e) => setSubNicheSelected(e.target.value)}
                        />
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
            }

            <FooterNaviBar
              back={() => handleNavigate('back')}
              next={() => handleNavigate('next')}
            />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default StepNinche
